const inr = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  maximumFractionDigits: 0,
});

export const formatPrice = (n: number) => inr.format(n);

export const discountPercent = (price: number, compareAt?: number) =>
  compareAt && compareAt > price ? Math.round(((compareAt - price) / compareAt) * 100) : 0;

export function formatDate(iso: string, withTime = false) {
  const d = new Date(iso);
  return d.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {}),
  });
}

export const formatNumber = (n: number) => new Intl.NumberFormat('en-IN').format(n);

export const titleCase = (s: string) =>
  s.toLowerCase().replace(/(^|[_\s])(\w)/g, (_, sep, c) => (sep ? ' ' : '') + c.toUpperCase());

export const initials = (name: string) =>
  name
    .split(' ')
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

/** ₹1.2L / ₹3.4K style, for chart axes and dense KPI text. */
export function formatCompact(n: number) {
  const a = Math.abs(n);
  if (a >= 10_000_000) return `₹${(n / 10_000_000).toFixed(1)}Cr`;
  if (a >= 100_000) return `₹${(n / 100_000).toFixed(1)}L`;
  if (a >= 1000) return `₹${(n / 1000).toFixed(a >= 10_000 ? 0 : 1)}K`;
  return `₹${Math.round(n)}`;
}

export const formatPercent = (n: number, digits = 1) => `${n.toFixed(digits)}%`;

/** % change vs previous period; null when there is no baseline. */
export const pctChange = (value: number, previous: number) => (previous === 0 ? null : ((value - previous) / previous) * 100);

export const shortDate = (iso: string) => new Date(iso).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });

/** ISO <-> <input type="date|datetime-local"> values. */
export const isoToDateInput = (iso?: string) => (iso ? new Date(iso).toISOString().slice(0, 10) : '');
export const isoToDateTimeInput = (iso?: string) => {
  if (!iso) return '';
  const d = new Date(iso);
  const off = d.getTimezoneOffset() * 60000;
  return new Date(d.getTime() - off).toISOString().slice(0, 16);
};
export const dateInputToIso = (v: string, endOfDay = false) => (v ? new Date(`${v}T${endOfDay ? '23:59:00' : '00:00:00'}Z`).toISOString() : undefined);
export const dateTimeInputToIso = (v: string) => (v ? new Date(v).toISOString() : undefined);
